import { ServerErrorCode } from 'app/data/enum/ServerErrorCode';

export class ServerErrorDTO {

  public errorCode: ServerErrorCode;

  public errorDescription: string;

}
